import { render, staticRenderFns } from "./TusAsientosComponent.vue?vue&type=template&id=d6c0f622"
import script from "./TusAsientosComponent.vue?vue&type=script&lang=js"
export * from "./TusAsientosComponent.vue?vue&type=script&lang=js"
import style0 from "./TusAsientosComponent.vue?vue&type=style&index=0&id=d6c0f622&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports